"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var request = require('axios');
var _require = require('buffer/'),
  Buffer = _require.Buffer;
var IS_DEV = process.env.NODE_ENV !== 'production';
var Flagr = /*#__PURE__*/_createClass(
/**
* Initiates the library.
*
* @param flagrUrl          The base url of the flagr instance.
* @param staticFlags       A a json object containing hard coded flags.
*                          These will be used in development mode.
* @param extraParams       Extra params for init, these will be send in every req.
*/
function Flagr(_ref) {
  var _this = this;
  var flagrUrl = _ref.flagrUrl,
    staticFlags = _ref.staticFlags,
    extraParams = _ref.extraParams;
  _classCallCheck(this, Flagr);
  /**
  * Evaluates a flag.
  *
  * @param flagKey         The name of the flag (flagKey in flagr).
  * @param entityID        The id of the entity (user). Flagr will cache results for entities.
  * @param entityContext   Additional params for the entity, like country and city.
  *
  * @returns {Promise}     The evaluated flag, will be of the following structure:
  *                        {
  *                          ...
  *                          flagID: 2,
  *                          flagKey: 'test_flag',
  *                          variantAttachment: {
  *                            name: 'tomas'
  *                          },
  *                          variantID: 5,
  *                          variantKey: 'tomas'
  *                        }
  */
  _defineProperty(this, "get", function (flagKey) {
    var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref2$entityID = _ref2.entityID,
      entityID = _ref2$entityID === void 0 ? null : _ref2$entityID,
      _ref2$entityContext = _ref2.entityContext,
      entityContext = _ref2$entityContext === void 0 ? {} : _ref2$entityContext;
    // Use the local flags map in development mode.
    if (IS_DEV) {
      return Promise.resolve(_this.flagsMap[flagKey]);
    }
    var evalArgs = {
      flagKey: flagKey,
      entityID: entityID,
      entityContext: _objectSpread(_objectSpread({}, entityContext), _this.extraParams)
    };
    return request.post("".concat(_this.flagrUrl, "/api/v1/evaluation"), evalArgs).then(function (r) {
      return r.data;
    });
  });
  _defineProperty(this, "getBatch", function (flagKeys) {
    var _ref3 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref3$entityID = _ref3.entityID,
      entityID = _ref3$entityID === void 0 ? null : _ref3$entityID,
      _ref3$entityContext = _ref3.entityContext,
      entityContext = _ref3$entityContext === void 0 ? {} : _ref3$entityContext;
    // Use the local flags map in development mode.
    if (IS_DEV) {
      var evaluationResults = [];
      flagKeys.forEach(function (flagKey) {
        evaluationResults.push(_objectSpread({
          flagKey: flagKey
        }, _this.flagsMap[flagKey]));
      });
      return Promise.resolve({
        evaluationResults: evaluationResults
      });
    }
    var evalArgs = {
      flagKeys: flagKeys,
      entities: [{
        entityID: entityID,
        entityContext: _objectSpread(_objectSpread({}, entityContext), _this.extraParams)
      }]
    };
    return request.post("".concat(_this.flagrUrl, "/api/v1/evaluation/batch"), evalArgs).then(function (r) {
      return r.data;
    });
  });
  // Prevent stupid errors.
  if (!IS_DEV && !flagrUrl) {
    throw new Error('Please enter flagrUrl in production mode.');
  } else if (IS_DEV && !staticFlags) {
    throw new Error('Please enter staticFlagsPath in development mode.');
  }
  this.flagrUrl = flagrUrl;
  this.extraParams = extraParams;
  if (IS_DEV) {
    var flagsObj = staticFlags;
    // Handle read file from node.js.
    if (flagsObj instanceof Buffer) {
      flagsObj = JSON.parse(staticFlags);
    }
    this.flagsMap = flagsObj;
  }
});
module.exports = {
  Flagr: Flagr
};